import React from 'react';
import _ from 'lodash';
import Link from 'next/link';
import PropTypes from 'prop-types';

// @ts-expect-error [🤖 PLEASE FIX 🤖]: Binding element 'items' implicitly has an 'any' type.
const LinkList = ({ items }) => (
  <ul>
    {_.map(items, (item) => (
      <li key={`link-list-${_.kebabCase(item.title)}`}>
        <Link href={item.url} as={item.as}>
          {item.title}
        </Link>

        {item.children && <LinkList items={item.children} />}
      </li>
    ))}
  </ul>
);

LinkList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default LinkList;
